/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LiveSearchService } from '../liveSearch.service';
import { Store } from '@ngxs/store';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import {
    MatAutocompleteSelectedEvent,
    MatAutocompleteTrigger,
    MatAutocomplete,
    MatOption,
} from '@angular/material/autocomplete';
import { AppConfigState } from '../../../../../core/state/appConfig/app-config.state';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'dash-gis-live-search-custom-ui',
    templateUrl: './live-search-custom-ui.component.html',
    styleUrls: ['./live-search-custom-ui.component.scss'],
    imports: [FormsModule, MatAutocompleteTrigger, ReactiveFormsModule, MatAutocomplete, MatOption, AsyncPipe],
})
export class LiveSearchCustomUiComponent implements OnInit {
    @Input() placeholder = 'Search';

    searchResults$: Observable<any>;
    liveSearchControl = new FormControl<string>('');

    #dispose$ = new Subject<boolean>();

    constructor(private liveSearchService: LiveSearchService, private store: Store) {}

    ngOnInit(): void {
        this.searchResults$ = this.liveSearchControl.valueChanges.pipe(
            debounceTime(50),
            switchMap((v) => this.liveSearchService.search(v)),
            takeUntil(this.#dispose$)
        );
    }

    formatSelected(item: any) {
        if (item) {
            return item.display[0];
        } else {
            return item;
        }
    }

    onOptionSelected(ev: MatAutocompleteSelectedEvent) {
        if (ev.option) {
            this.zoomTo(ev.option.value);
        }
    }

    zoomTo(item) {
        const liveSearchConfig = this.store.selectSnapshot(AppConfigState.liveResults);
        this.liveSearchService.zoom(liveSearchConfig.layer, liveSearchConfig.key, item.key);
    }
}
